module.exports = __webpack_public_path__ + "img/soc.83fda018.svg";